// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__bVbxE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2cTI0"};